import './product-video-icon.scss';
import Tooltip from 'tooltip.js';

ComponentRegistry.register(function ($context) {
    return $context.find('.product-video-icon')
}, function ($item) {
    new Tooltip($item, {
        container: document.body,
        html: true,
        title: 'Есть видео',
        placement: 'top',
        offset: '0, 10'
    });
});